document.querySelectorAll('.grid-meta-color li').forEach((color) => {
  color.addEventListener('mouseover',function(){
    if(color.querySelector('img') != null && color.closest('.snippet-product-grid') != null){
      color.closest('.snippet-product-grid').querySelector('.product-images img').setAttribute('srcset',color.querySelector('img').getAttribute('src'))
    }
  })
  color.addEventListener('mouseout',function(){
    if(color.querySelector('img') != null && color.closest('.snippet-product-grid') != null){
      color.closest('.snippet-product-grid').querySelector('.product-images img').setAttribute('srcset',color.closest('.grid-meta-color').querySelector('li a.active img').getAttribute('src'))
    }
  })
})